import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HeaderMobileComponent } from './header-mobile.component';

const routes: Routes = [
    { path: '*', component: HeaderMobileComponent }
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/header-mobile/header-mobile.routing.ts